<template>
  <v-row>
    <v-col cols="12">
      <v-text-field
        name="name"
        :value="value.name"
        :counter="65"
        :rules="rules.name"
        :readonly="readonly"
        :error-messages="errors.name"
        :label="`${$t('ABO_SERVICES.APP_NAME')} *`"
        @input="updateValue('name', $event)"
      />
    </v-col>
  </v-row>
</template>

<script>
import { maxLength, notEmpty } from '@/modules/_global/variables/rules';
import formEditable from '@/modules/_global/mixins/form-editable';

export default {
  name: 'AboServiceTranslationForm',

  mixins: [formEditable],

  props: {
    languageId: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      valid: true,
      rules: {
        name: [notEmpty, maxLength(65)]
      }
    };
  },

  methods: {
    updateValue(key, value) {
      this.$emit('update-prop', key, value);
      this.$emit('input', {
        ...this.value,
        language_id: this.languageId,
        [key]: value
      });
    }
  }
};
</script>
